const getters = {
  getCategories(store) {
    return store.categories
      ? store.categories.filter((category) => category.products.length !== 0)
      : [];
  },
  getCity(store) {
    return store.city;
  },
  getSuperCategories(store) {
    return store.superCategories;
  },
  getCurrentProduct(store) {
    return store.currentProduct;
  },
  getProductsSuggestions(store) {
    return store.productsSuggestions ? store.productsSuggestions : [];
  },
  getProductsSearch(store) {
    return store.productsSearch ? store.productsSearch : [];
  },
  getIsLoadingCategories(store) {
    return store.isLoadingCategories;
  },
  getCurrentSuperCategory(store) {
    return store.currentSuperCategory;
  },
  getCurrentCategory(store) {
    return store.currentCategory;
  },
  getProductRecommendations(store) {
    return store.productRecommendations;
  },
};

export default getters;
